import './App.css';
import { Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import FooterSection from './sections/FooterSection';
import HomePage from './pages/HomePage';
import NowPage from './pages/NowPage';
import PageNotFound from './sections/PageNotFound';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/now" element={<NowPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <FooterSection />
    </div>
  );
}

export default App;
